import { object } from "yup";

import { TASK_MESSAGE } from "../../../validation/taskManagement";

export const commentMessage = object().shape({
  text: TASK_MESSAGE,
});
